export default {
	PRIMARY_CUSTOMER_VEHICLE: "pc_veh"
};